import React, { useEffect, useState } from "react"
import { AgilityImage } from "@agility/gatsby-image-agilitycms"
import { renderHTML } from "../../agility/utils"
import { useSiteContext } from "../common/SiteContext"
import { Script } from "gatsby"
import { Helmet } from "react-helmet"

const VineyardGazetteCalendar = ({ dynamicPageItem }) => {
  const [vineyardGazetteLoaded, setVineyardGazetteLoaded] = useState(false)

  const [isClient, setClient] = useState(false);
  const key = isClient ? "client-calendar" : "server-calendar";

  useEffect(() => {
    setClient(true);
  }, []);

  return (<>
    <Helmet>
      <script src="https://calendar.vineyardgazette.com/widget/view?schools=mvgazette&amp;days=31&amp;num=50&amp;container=localist-widget-88572134&amp;template=modern"/>
    </Helmet>
    <div id={"localist-widget-88572134"} className={`localist-widget mx-auto max-w-screen-lg`}/>    
    <div id="lclst_widget_footer">
      <a style={{marginLeft: 'auto', marginRight:'auto', display:'block', width:'81px', marginTop:'10px'}} title="Widget powered by Localist Event Calendar Software" href="https://www.localist.com?utm_source=widget&amp;utm_campaign=widget_footer&amp;utm_medium=branded%20link">
        <img src="//d3e1o4bcbhmj8g.cloudfront.net/assets/platforms/default/about/widget_footer.png" alt="Localist Online Calendar Software" style={{verticalAlign:'middle'}} width="81" height="23" />
      </a>
    </div>

  </>
  )
}

export default VineyardGazetteCalendar
